module.exports = __webpack_public_path__ + "img/rural1.6290d6e1.jpg";